var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.f),expression:"f"}]},[(_vm.show)?_c('div',{ref:"lazy-content"},[_vm._t("default")],2):_c('div',{style:(`height:${_vm.maskHeight}px`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }